"use strict";
exports.__esModule = true;
var MediaProvider = /** @class */ (function () {
    function MediaProvider(mediaFactory, mediaPayload, providerInstance) {
        this.mediaFactory = mediaFactory;
        this.mediaPayload = mediaPayload;
        this.providerInstance = providerInstance;
        this.mediaList = this.formatMedia(this.mediaPayload);
        this.priorityMediaList = this.definePriorityMedia(this.mediaList);
    }
    MediaProvider.prototype.formatMedia = function (mediaList) {
        var _this = this;
        if (!mediaList) {
            return {};
        }
        return Object.keys(mediaList).reduce(function (obj, section) {
            var sectionName = _this.providerInstance.getProviderName(section);
            obj[sectionName] = mediaList[section].map(function (media) { return _this.mediaFactory(media); });
            return obj;
        }, {});
    };
    MediaProvider.prototype.definePriorityMedia = function (formattedMedias) {
        var priorityKey = this.providerInstance.PRIORITY.find(function (key) { return formattedMedias[key] && formattedMedias[key].length > 0; });
        return priorityKey ? formattedMedias[priorityKey] : [];
    };
    return MediaProvider;
}());
exports.MediaProvider = MediaProvider;
//# sourceMappingURL=media-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/media/media-provider.js
// module id = 159
// module chunks = 0